module.exports = __webpack_public_path__ + "static/media/legionella_3.1c61076f.svg";